import React from "react";

const Data_Types = () => {
  return (
    <div>
      <h1>Data_Types Component</h1>
      <p>Content for Data_Types goes here...</p>
    </div>
  );
};

export default Data_Types;
